<template>
  <div id="landing-app">
    <router-view />
    <top-toast :visible="! online" />
  </div>
</template>

<script>
import TopToast from '@landing/landing-desktop/components/TopToast'
import domMixin from '@landing/common/mixins/domMixin'
import networkStatusMixin from '@landing/landing-desktop/mixins/networkStatusMixin'
import { clearStore } from '@landing/landing-desktop/redux/reducers'
import { setCart, setPageToCart } from '@landing/landing-desktop/redux/reducers/cart'
import { setOrder } from '@landing/landing-desktop/redux/reducers/order'
import { setPage, setSite } from '@landing/landing-desktop/redux/reducers/page'
import Tracker from '@landing/landing-common/models/Tracker'
import Vue from '@landing/landing-desktop/consts/vue'
import setConst from '@landing-desktop/utils/setConst'

export default {
  name: 'App',
  components: {
    TopToast
  },
  mixins: [domMixin, networkStatusMixin],
  props: {
    site: Object,
    page: Object,
    cart: Object,
    order: Object,
    url: String
  },
  data() {
    return this.mapState({
      online: 'app.online',
      pageData: 'page.page'
    })
  },
  beforeCreate() {
    this.mapDispatch({
      setPage,
      setSite,
      setOrder,
      setCart,
      setPageToCart,
      clearStore
    })
    this.store.unsubscribeAll()
    this.clearStore()
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      Vue.prototype.$url = this.url
      const { page } = this
      this.setSite(this.site)
      this.setPage(page)
      this.setPageToCart(page)
      this.setCart(this.cart)
      this.setOrder(this.order)

      if (this.isClient) {
        Vue.prototype.$tracker = new Tracker({
          page: this.pageData,
          site: this.site,
          cart: this.cart
        })
      }
      setConst(page)
    }
  }
}
</script>
